import FavoriteStore from './FavoriteStore';

const favoriteStore = new FavoriteStore();

export default favoriteStore;
